/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    export class DealcontactsDialog extends NoboxEntityDialog<DealcontactsRow, any> {
        protected getFormKey() { return DealcontactsForm.formKey; }
        protected getIdProperty() { return DealcontactsRow.idProperty; }
        protected getLocalTextPrefix() { return DealcontactsRow.localTextPrefix; }
        protected getNameProperty() { return DealcontactsRow.nameProperty; }
        protected getService() { return DealcontactsService.baseUrl; }
        protected getDeletePermission() { return DealcontactsRow.deletePermission; }
        protected getInsertPermission() { return DealcontactsRow.insertPermission; }
        protected getUpdatePermission() { return DealcontactsRow.updatePermission; }

        protected form = new DealcontactsForm(this.idPrefix);

    }
}